/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * grimoire/v1/api.proto
 * OpenAPI spec version: version not set
 */

/**
 * Month represents months of the year.

 - MONTH_UNSPECIFIED: Unspecified month.
 - MONTH_JANUARY: January.
 - MONTH_FEBRUARY: February.
 - MONTH_MARCH: March.
 - MONTH_APRIL: April.
 - MONTH_MAY: May.
 - MONTH_JUNE: June.
 - MONTH_JULY: July.
 - MONTH_AUGUST: August.
 - MONTH_SEPTEMBER: September.
 - MONTH_OCTOBER: October.
 - MONTH_NOVEMBER: November.
 - MONTH_DECEMBER: December.
 */
export type V1Month = (typeof V1Month)[keyof typeof V1Month];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1Month = {
  MONTH_UNSPECIFIED: 'MONTH_UNSPECIFIED',
  MONTH_JANUARY: 'MONTH_JANUARY',
  MONTH_FEBRUARY: 'MONTH_FEBRUARY',
  MONTH_MARCH: 'MONTH_MARCH',
  MONTH_APRIL: 'MONTH_APRIL',
  MONTH_MAY: 'MONTH_MAY',
  MONTH_JUNE: 'MONTH_JUNE',
  MONTH_JULY: 'MONTH_JULY',
  MONTH_AUGUST: 'MONTH_AUGUST',
  MONTH_SEPTEMBER: 'MONTH_SEPTEMBER',
  MONTH_OCTOBER: 'MONTH_OCTOBER',
  MONTH_NOVEMBER: 'MONTH_NOVEMBER',
  MONTH_DECEMBER: 'MONTH_DECEMBER',
} as const;
